"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListRow = exports.renderCustomMeta = exports.findOption = exports.getTarget = void 0;
var React = require("react");
var memoize = require("fast-memoize");
var components_1 = require("components");
var react_router_dom_1 = require("react-router-dom");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var ListRow_1 = require("views/FileListOverview/FileList/ListRow");
var preview_1 = require("utils/preview");
var FileIcon_1 = require("components/FileIcon");
var filesMemoize_1 = require("utils/helpers/filesMemoize");
var sokoSiteRouter_1 = require("../../../routers/ProjectRouter/sokoSiteRouter");
var RenderFileLink_1 = require("components/RenderFileLink/RenderFileLink");
var getTarget = function (file, isMobile) {
    if (isMobile) {
        switch (file.type) {
            case 'PDF':
                return '_blank';
            case 'PRESENTATION':
            case 'SPREADSHEET':
            case 'TEXT':
                if (/\.(doc|docx|ppt|pps|pptx|xls|xlsx)$/i.test(file.name)) {
                    return '_blank';
                }
        }
    }
    return undefined;
};
exports.getTarget = getTarget;
exports.findOption = memoize(function (meta, value) {
    return meta.options && meta.options.find(function (o) { return o.value === value; });
});
exports.renderCustomMeta = memoize(function (cols, file, baseUrl, isMobile, token) {
    var elements = [];
    var columns = cols.columnMap;
    if (!columns) {
        return elements;
    }
    columns.forEach(function (c, key) {
        if (c.id === undefined) {
            return;
        }
        var dataKey = '__' + c.id;
        if (c.identifier === 'name-meta') {
            elements.push(React.createElement(RenderFileLink_1.RenderFileLink, { key: key, file: file, baseUrl: baseUrl, isMobile: isMobile, token: token, dataKey: dataKey, index: key, createLink: preview_1.createLink, getTarget: exports.getTarget, filename: (0, sokoSiteRouter_1.getLocalizedFilename)(file) }));
            return;
        }
        var value = (0, ListRow_1.formatMetadata)(c.identifier, file.customMeta[c.id], c);
        elements.push(React.createElement("div", { "data-length": value.toString().length, key: c.id, className: 'row__column ' + dataKey },
            React.createElement("span", null, value)));
    });
    return elements;
}, filesMemoize_1.memoizeSerializer);
exports.ListRow = (0, ListRow_1.enhanceRow)(React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var isMobile = data.isMobile, mode = data.mode, items = data.items, columns = data.columns, baseUrl = data.baseUrl, itemSelections = data.itemSelections, downloadFolder = data.downloadFolder, convert = data.convert, openNotificationsSideMenu = data.openNotificationsSideMenu, navigateTo = data.navigateTo, toggleItem = data.toggleItem, onBookmark = data.onBookmark, onUnBookmark = data.onUnBookmark, token = data.token, hideActions = data.hideActions, hideDownload = data.hideDownload;
    var file = items[index];
    var selected = itemSelections[file.uuid];
    var downloadLinkUrl = "".concat(__UPLOADSERVERURL__, "/files/").concat(file.uuid);
    var url = baseUrl.replace(/\/[^\/]*$/, '/' + file.parent);
    return (React.createElement("div", { className: className + ' ' + (file.type !== 'FOLDER' ? 'file' : ''), style: style },
        React.createElement("div", { className: "row__column first narrow icon" },
            React.createElement("div", { className: 'file-icon' }, (0, FileIcon_1.typeToIconAndTextMap)(file.type).icon)),
        React.createElement("div", { className: "row__column narrow" },
            React.createElement(components_1.TableRowIcon, { icon: 'fa-check', circle: true, className: selected ? 'selected' : null, onClick: function (e) {
                    e.stopPropagation();
                    toggleItem(file);
                } })),
        React.createElement("div", { className: 'row__column narrow download icon' }, file.type === 'FOLDER' ? (React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/files/toolTip/downloadFolder')) },
            React.createElement(sok_ui_1.Icon, { className: 'sok-icon-download-cloud sok-icon-download-cloud-center', onClick: function () {
                    downloadFolder(file);
                } }))) : (React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/files/toolTip/downloadFile')) },
            React.createElement("a", { href: downloadLinkUrl, target: "_blank" },
                React.createElement(sok_ui_1.Icon, { className: 'sok-icon-download-cloud sok-icon-download-cloud-center' }))))),
        mode === 'SEARCH' ? (React.createElement("div", { className: "row__column go-to narrow" },
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('fileslist/listrow/gotoFolder')) },
                React.createElement(react_router_dom_1.Link, { to: url },
                    React.createElement(components_1.TableRowIcon, { icon: 'fa-angle-double-right' }))))) : null,
        (0, ListRow_1.preview2D3DCell)(file, baseUrl, token, convert, navigateTo),
        (0, exports.renderCustomMeta)(columns, file, baseUrl, isMobile, token)));
}, function (nextProps, props) {
    if (nextProps.data !== props.data) {
        return false;
    }
    return true;
}));
